import { useContext } from "react";
import { AccountContext } from "../AccountContext";

interface UseClientIdReturnType {
  clientId: number;
  setClientId: (id: number) => void;
}

export function useClientId(): UseClientIdReturnType {
  const { clientId, setClientId } = useContext(AccountContext);
  const setId = (id: number) => {
    // TODO: Check if clientId changed and clear everything?
    setClientId(id);
  };

  return { clientId, setClientId: setId };
}
